import React from 'react';
import { getDefaultName, talentImageSrc } from '../../../utils';

const DEFAULT_IMAGE = '/assets/images/default.png';

export default function TalentCardsWidget({ talents, showDelete, loading, onDelete, topLevelOnly = true }) {
    const items = topLevelOnly
        ? (talents || []).filter((item) => parseInt(item.parent || 0, 10) === 0)
        : (talents || []);

    return (
        <div className="talent-cards-grid">
            {items.map((item) => (
                <div key={item.id} className="talent-card-col">
                    <div className="talent-card">
                        {showDelete && (
                            <button
                                type="button"
                                className="btn btn-danger btn-xs"
                                style={{ position: 'absolute', right: '8px', top: '8px', zIndex: 2 }}
                                onClick={(e) => {
                                    if (window.confirm('Are you sure you wish to delete this item?')) onDelete(item.id, e);
                                }}
                            >
                                <i className="fa fa-trash"></i>
                            </button>
                        )}
                        <a href={`/cms/talents/${item.id}`} style={{ textDecoration: 'none' }}>
                            <img
                                className="talent-card-img"
                                src={talentImageSrc(item, DEFAULT_IMAGE)}
                                alt={getDefaultName(item.names)}
                            />
                            <div className="talent-card-name">
                                {loading === item.id ? 'Loading...' : getDefaultName(item.names)}
                            </div>
                        </a>
                        <a
                            className="talent-card-count"
                            href={`/cms/talent/${item.id}`}
                            title="View participants"
                            style={{ textDecoration: 'none' }}
                        >
                            <i className="fa fa-users"></i>
                            {(item.count_of_usertalents || 0).toLocaleString()}
                        </a>
                    </div>
                </div>
            ))}
        </div>
    );
}
